import { constants } from '../utils'
import base from './base'

const { headers, url, request } = base

const getAll = async () =>
  request(url(constants.api.electricalPowerOperators.index), {
    method: 'GET',
    headers: headers(),
  })

const energyApi = { getAll }
export default energyApi
